import Dexie from "dexie";

//Dexie.delete(process.env.VUE_APP_INDEXEDDB_NAME);

const db = new Dexie(process.env.VUE_APP_INDEXEDDB_NAME);

const initDB = async (ebookcode)=>{


    localStorage.ebookcode = ebookcode;

    db.close();

    /*
    db.version(1).stores({
        reader: "++id, [membercode+ebookcode], lastRead"
    });
     */
    db.version(2).stores({
        reader: "++id, [membercode+ebookcode], lastRead, toolHistory"
    }).upgrade(trans => {});

    db.version(3).stores({
        reader: "++id, [membercode+ebookcode], lastRead, toolHistory, hasLocalChange"
    }).upgrade(trans => {});

    db.version(4).stores({
        reader: "++id, [membercode+ebookcode], lastRead, toolHistory, pagesWithLocalChange"
    }).upgrade(trans => {});

    return await db.open();

}


const getRecord = async ()=>{

    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .first();
}

export { db, initDB }